import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Accordion } from "@cinch-nx/shared-ui";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import sharedStyles from "../../landing-feature-electric-cars.module.css";
export const EvFaqs = ({ title , faqs  })=>{
    const accordionItems = faqs.map((faq)=>({
            title: faq.title,
            children: ()=>/*#__PURE__*/ _jsx(_Fragment, {
                    children: renderWithResolver(faq.body)
                })
        }));
    return /*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsx("h3", {
                id: "faq-section",
                className: sharedStyles.heading,
                children: title
            }),
            /*#__PURE__*/ _jsx(Accordion, {
                title: title,
                items: accordionItems,
                buttonId: title,
                sectionId: "ev-faq-section"
            })
        ]
    });
};
